<template>
<div>

<!--<spinner v-bind:spinner='spinner'></spinner>-->
 <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

<div class="modal" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div style="background-color:#FFFF66" class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">
           <i  class="far fa-clone mr-2" aria-hidden="true"></i>
          <strong>UNIFICAZIONE DOCUMENTI</strong></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div style="color:brown" class="modal-body">
        
        DA DOCUMENTO ID 
         <span><strong>{{documentId_From}}</strong></span>
          A DOCUMENTO ID 
          <span><strong>{{documentId_To}}</strong></span>
          
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">ANNULLA</button>
        <button @click="updateMovement()"  type="button" class="btn btn-primary">ESEGUI</button>
      </div>
    </div>
  </div>
</div>


<edit-header @update="setRowData" v-bind:documentId="documentId" :key="refresh"></edit-header>

<div class="table-wrapper-scroll-y my-custom-scrollbar">
    <table class="table table-hover _table-striped mb-0" id="table">
    <thead >
    <tr>
        <th>#</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th>FORNITORE</th> 
        <th>DOCUMENTO ID</th>
        <th>MOVIMENTO ID</th>
        <th>CREATO IL</th>
        
        <th>SEDE</th>
        <th>STAGIONE</th>
        <th>TIPO</th>
        <th>NUMERO</th>
        <th>DATA</th>
        <th class="text-right">Q.TA'</th>
        <th class="text-right">IMPONIBILE</th>
        <th class="text-right">IVA</th>
        <th class="text-right">TOTALE</th>
          
        
        <!--<th></th>-->

    </tr>
    </thead>
    <tbody>
    <tr draggable="true"
        @dragstart='startDrag($event, item)' 
        @drop='onDrop($event, item)' 
        @dragover.prevent
        @dragenter.prevent
        @dblclick="openRow(item)" class="pointer" v-for="(item,index) in filteredDocuments" :key="index">
        <td>{{index+1}}</td> 
       <td>
        <i v-if="item.qty==0" @click="deleteItem(item)"  data-toggle="tooltip" title="Elimina"  v-bind:class="item.movementType=='AC' ||  item.movementType=='RF' ? 'fas fa-trash':''" aria-hidden="true"> </i>
       </td>   
       <td>
               
       </td>  
        <td>
          <i v-bind:style="{ color: item.movementType == 'AC' ? '#669900':'#669900'}"
           v-bind:class="item.movementType == 'AC' ? 'fas fa-square' : 'far fa-square'" aria-hidden="true"></i>
        </td>
        
        <td>
          <div class="dropdown">
            <button style="color:black;background-color: white;" class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-cog mr-2" aria-hidden="true"></i>
            Opzioni
          </button>
          <div class="dropdown-menu ">

            <a v-if="item.movementType == 'RF'" class="dropdown-item" @click="$emit('PackingList',item)"  href="#">
                <i style="color:black" class="fas fa-print mr-2" aria-hidden="true"></i>
                STAMPA PACKING LIST
           </a>
           
            <a v-if="item.movementType == 'RF'" class="dropdown-item" @click="$emit('print_pdf',item)"  href="#">
                <i style="color:black" class="fas fa-print mr-2" aria-hidden="true"></i>
                STAMPA DDT 
           </a>

              <a class="dropdown-item"  @click="editHeader(item.documentId)"  href="#">
                <i style="color:black" class="far fa-edit mr-2" aria-hidden="true"></i>
                MODIFICA INTESTAZIONE </a>
              <a class="dropdown-item" @click="$emit('edit',item)"  href="#">
                <i style="color:black" class="far fa-edit mr-2" aria-hidden="true"></i>
                MODIFICA SCONTO  </a>
                <a class="dropdown-item" @click="$emit('editVat',item)" href="#">
                <i style="color:black" class="far fa-edit mr-2" aria-hidden="true"></i>
                MODIFICA IVA  </a>
                <a class="dropdown-item" @click="eventLog(item)" href="#">
                <i style="color:black" class="far fa-edit mr-2" aria-hidden="true"></i>
                NOTE  </a>  
              <!--<a class="dropdown-item" @click="getProductData(2,item)" href="#">CHECK LIST SINTETICA</a>-->
            </div>
          </div>    
        </td>




        
        
        <td>{{item.supplier}}</td>  
        <td>{{item.documentId}}</td>
        <td>{{item.stockMovementId}}</td>

        <td>{{item.create_at}}</td>
        <td>{{item.store}}</td>
        <td>{{item.data}}</td>
        <td>{{item.description}} - {{item.movementType}}</td>

        <td>{{item.number}}</td>
        <td>{{item.date}}</td>
        <td class="text-right total">{{item.qty}}</td>
        <td class="text-right total">{{item.taxable.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</td>
        <td class="text-right total">{{item.tax.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</td>
        <td class="text-right total">{{item.total.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</td>
     
       
    </tr>
    </tbody>





    <tfoot>

    <tr v-for="(item,index) in filteredTotal" :key="index">

       <td>
       </td>   
       <td>
         
        </td>

       
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>

        <td></td>
        <td></td>
        <td></td>
        <td></td>

        <td></td>
        <td></td>
        <td></td>
        <td class="text-right"><strong>{{item.TotalQty.toLocaleString('de-DE',{ style: 'decimal' })}}</strong></td>
        <td class="text-right"><strong>{{item.TotalTaxable.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</strong></td>
        <td class="text-right"><strong>{{item.TotalTax.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</strong></td>
        <td class="text-right"><strong>{{item.GrandTotal.toLocaleString('de-DE',{ style: 'currency', currency: 'EUR' })}}</strong></td>
     

    </tr>
    </tfoot>  
    </table>
  </div>        
  
  <div class="mt-2 mb-2">
  <label for="cerca"><strong>
     <i  class="fas fa-filter mr-2" aria-hidden="true"></i>
    Filtra</strong></label>
         <input class="form-control" type="text" name="query" v-model="filterKey">
  
  </div>
  <button v-if="filteredDocuments.length > 0" @click="exportToPDF(filteredDocuments,filteredTotal,props.data1,props.data2)" class="btn btn-success btn-block border border-warning  mb-1">
      <i style="color:black" class="fas fa-file-export mr-2" aria-hidden="true"></i>
      ESPORTA IN PDF
</button>

  <event-log  v-if="eventData.event_key" @close="eventData.event_key=0" v-bind:item_key="eventData.event_key" v-bind:item_type="eventData.event_type" v-bind:item_header="eventData.event_header"  ></event-log>  

     <confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">
          
          NO</button>
        <button @click="processModal()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
    </confirm-box>  



  </div>





</template>

<script>
import eventLog                  from '@/components/common/EventLog.vue'
import api                       from '@/api'

import alertBox                  from '@/components/common/AlertBox.vue';
import editHeader                from '@/components/shipping/EditHeaderDocument.vue';
import confirmBox                from '@/components/common/ConfirmBox.vue'
import printMovements            from '@/components/mixins/SuppliersMovementsPDF.js'
  export default {
    mixins: [printMovements],
    props : ['props'],
    
    components: {alertBox,editHeader,eventLog,confirmBox},
    data () {
      return {
        
        cb            : {title : '',msg1 : '',show:false,documentId:0,movementId:0},

        refresh       : 0,
        items         : [],
        filterKey     : '',
        spinner       : false,
        movementId_To : 0,
        movementId_From : 0,
        msg             : {
                title : '',
                body  : '',
                type  : 0      
        },
        
        
        documentId_To   : '',
        documentId_From : '',
        documentId      : 0,
        eventData       : {

        event_key            : 0,
        event_type           : '',
        event_header         : ''  
      },
      rowTotal               : [] 
        
        
      }
    },

    

    computed: {
      
      
      filteredDocuments : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },

     filteredTotal  : function () 
      {
        
        let TotalQty     = 0
        let TotalTaxable = 0
        let TotalTax     = 0
        let GrandTotal   = 0
        
        var filterKey    = this.filterKey && this.filterKey.toLowerCase()
        var total        = this.rowTotal
       
        var items        = []

        if (filterKey) 
        {
          total = []
          items = this.filteredDocuments.filter(function (row) 
          {
            return Object.keys(row).some(function (key) 
            {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
          items.forEach(item => {
              TotalQty     += item.qty
              TotalTaxable += item.taxable
              TotalTax     += item.tax
              GrandTotal   += item.total
          })

          total.push({'TotalQty':TotalQty,'TotalTaxable':TotalTaxable,'TotalTax':TotalTax,'GrandTotal':GrandTotal})

        }
        
        return total

     },
     
  
      
    },
    mounted()
    { 
      
    },
    created () 
    {
      
      this.getData()

    },
    methods: 
    {

     deleteItem(item)
     {
       if(item.qty > 0)
       {
         return
       }
        this.cb.documentId = item.documentId
        this.cb.movementId = item.stockMovementId
        this.cb.title = 'ELIMINA RIGA '
        this.cb.msg1  = 'SI DESIDERA ELIMINARE LA RIGA CON DOCUMENTO ID ' + item.documentId +  ' ?'
        this.cb.show = true
     },
     
     async processModal()
     {
        
        this.cb.show = false
        this.spinner = true
        var data     = {'movementId' : this.cb.movementId,'documentId':this.cb.documentId}        
        var sp       = {'sp' : 'spDeleteSupplierDocumentMovement'}
        var json     = Object.assign(data, sp);
        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.msg.title = 'ELIMINAZIONE EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
              this.getData()  

            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data 
              this.msg.type = 1
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1

            } 
        }).catch(err => 
        {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1

        }).finally(() => {
             this.spinner = false
        });
        
        
        
     
     }, 
     eventLog(item)
     {
        
        this.eventData.event_key = item.stockMovementId
        this.eventData.event_type = 'MOV'
        this.eventData.event_header = item.store + '   ' + item.create_at + ' ' + item.number + ' del ' + item.date
      
     },
     openRow(item)
     {
      this.msg.title = '' 
      if(item.movementType == 'RF') 
      {
        this.$emit('open', item)
      }
      else
      {
        this.msg.title = 'ATTENZIONE'
        this.msg.body = 'MODIFICARE IL MOVIMENTO DA CARICO DIRETTO.'
        this.msg.type = 1
      }
     },
     setRowData(data)
     {
        //console.log('Data',data)
        $('#modalEditHeader').modal('hide');
        this.getData()

     }, 
     editHeader(Id)
     {
       this.documentId = Id
       this.refresh++

        this.$nextTick(() => {
           $('#modalEditHeader').modal({keyboard: false,backdrop:'static','show':true});
            
        })

     },
     startDrag (evt, item) {
        
      
        this.msg.title = ''
        evt.dataTransfer.dropEffect = 'move'
        evt.dataTransfer.effectAllowed = 'move'
        evt.dataTransfer.setData('item_from', JSON.stringify(item))
      

      },
      onDrop (evt, item_to) {

      const item_from = JSON.parse(evt.dataTransfer.getData('item_from'))

      if(this.props.supplierId==0)
      {
         this.msg.title = 'ATTENZIONE '
        this.msg.body = 'UNIFICAZIONE DOCUMENTI NON CONSENTITA PER TUTTI I FORNITORI.'
        this.msg.type = 1
        return
      }

      if(item_from.stockMovementId != item_to.stockMovementId && item_from.movementType == item_to.movementType && item_from.storeId == item_to.storeId)
      {
        this.documentId_From = item_from.documentId
        this.documentId_To   = item_to.documentId
        this.movementId_To   = item_to.stockMovementId
        this.movementId_From = item_from.stockMovementId

        $('#staticBackdrop').modal('show')
    
      }
      else
      {
        

        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'RIGHE DOCUMENTO NON COMPATIBILI.'
        this.msg.type = 1
        
        
      }
      


      

      },

      
      async updateMovement()
      {
        this.msg.title = ''
        $('#staticBackdrop').modal('hide')
        this.spinner = true
        var data     = {'movementId_From' : this.movementId_From,'movementId_To' : this.movementId_To,'documentId':this.documentId_From}        
        var sp       = {'sp' : 'spUpdateMovementFromDragAndDrop'}
        var json     = Object.assign(data, sp);
        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.msg.title = 'UNIFICAZIONE EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
              this.getData()  

            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data 
              this.msg.type = 1
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1

            } 
        }).catch(err => 
        {
              console.log(err.message)    
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1

        }).finally(() => {
          //this.spinner = false
        });
        
        
        
     
      },
      
      
      
      async getData()
      {
        

        this.filterKey = ''
        this.items    = []
        this.rowTotal = []
        var data      = {'supplierId' : this.props.supplierId,'companyId' : this.props.companyId,
        'data1':this.props.data1,'data2':this.props.data2,'typeId':this.props.type,'mltp':this.props.mltp}
        
        var sp       = {'sp' : 'spSupplierMovements'}
        var json     = Object.assign(data, sp);
        await api.post(json).then(res => {
          if(res.status==200)
            {
                

                this.items = res.data.recordsets[0]
                
                if(this.items.length>0)
                {
                  this.rowTotal = res.data.recordsets[1]    
                }

            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
              console.log(err.message)    

        }).finally(() => {
           this.$emit('update',this.items.length)  
          //this.spinner = false
        });

  
      },
      
      

    }
  }
</script>

<style scoped>
  
.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}

.my-custom-scrollbar {
    position  : relative;
    height    : 500px;
    overflow  : auto;
    }
.table-wrapper-scroll-y {
    _display   : block;
  }
.total
{
  font-size   : 16px;
  
  font-weight : bold;

}  
p,th,span {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
  }

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : whitesmoke;
    color        : blue;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 } 
.table th:first-child
{
  border-radius : 0 0 0 8px;
  
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
.modal-footer {  
  justify-content: space-between;  
}
</style>
